import React, { createContext, useContext, useEffect, useState } from "react";

const dict = {
  en: {
    nav: { home: "Home", stays: "Stays", guides: "Travel Guides", creator: "Creator Stays", contact: "Contact", book: "Book now" },
    hero: {
      eyebrow: "South Tunisia & Island of Djerba",
      title: "A home on the island,",
      titleAccent: "wherever you wander.",
      sub: "Wostel Djerba is a community of travelers, hosts and storytellers — Hostel, Guest Houses and Apartments across the island, soon Matmata & Tataouine.",
      ctaPrimary: "See our stays",
      ctaSecondary: "Open the guides",
    },
    why: {
      eyebrow: "Why Wostel Djerba",
      title: "Not just beds.",
      titleAccent: "Experiences we craft.",
      cards: [
        { title: "Find your tribe", desc: "Arrive solo, leave with a squad. Rooftop dinners, beach days and stories that travel further than you do." },
        { title: "Authentic experiences", desc: "Our partner Sefer Tunisia takes you off the map — Berber villages, desert nights, fishing trips, hidden Djerba." },
        { title: "Best rates direct", desc: "Book direct via WhatsApp and skip platform fees. Same beds, lower price, more love for the team." },
        { title: "Across the south", desc: "Hostel, guest houses & apartments all over Djerba — and very soon, Matmata & Tataouine." },
      ],
    },
    ratings: {
      eyebrow: "Trusted by travellers",
      google: "on Google Reviews",
      hostelworld: "on Hostelworld",
    },
    offer: {
      eyebrow: "What we offer",
      title: "Three ways to stay,",
      titleAccent: "one community.",
      hostel: { name: "Hostel", desc: "The heart of Wostel — shared dorms, communal kitchen, rooftop sunsets and the loudest laughs in Djerba." },
      guest_house: { name: "Guest Houses", desc: "Authentic Djerbian houses with a courtyard, white walls and a blue door — privacy, your way." },
      apartment: { name: "Apartments", desc: "Your own space across the island — kitchen, terrace, sea breeze, working desk for digital nomads." },
    },
    activities: {
      eyebrow: "Things to do",
      title: "Discover Djerba with",
      titleAccent: "Sefer Tunisia.",
      desc: "Our partner Sefer Tunisia curates the most authentic experiences across Tunisia — desert nights in Matmata, Berber villages, sea trips and food walks.",
      cta: "Explore experiences",
    },
    featured: { eyebrow: "Featured stays", title: "Where you’ll sleep tonight." },
    stays: {
      title: "All our stays",
      sub: "Pick what fits your trip — community, privacy or independence.",
      filterAll: "All",
      filterHostel: "Hostel",
      filterGuest: "Guest Houses",
      filterApartment: "Apartments",
      bookHostelworld: "Book on Hostelworld",
      bookWhatsapp: "Book via WhatsApp",
      viewMap: "View on map",
      empty: "No stays in this category yet — come back soon!",
    },
    guides: {
      title: "Free travel guides",
      sub: "Crafted by our team and friends — download, print, get lost.",
      download: "Download PDF",
      empty: "Guides coming very soon.",
      chips: { pdfs: "Free PDFs", maps: "Local maps", offgrid: "Off-the-grid" },
    },
    creator: {
      title: "Free Content Creator Stays",
      sub: "Storyteller, photographer, filmmaker? Apply for a free stay in exchange for content that makes Djerba shine.",
      perks: { stay: "Free stay", tour: "Tour included", guide: "Local guide" },
      form: {
        full_name: "Full name", email: "Email", instagram: "Instagram handle", tiktok: "TikTok handle", youtube: "YouTube channel",
        audience_size: "Audience size (followers / subs)", preferred_dates: "Preferred dates", message: "Tell us about yourself & your idea",
        submit: "Send my application",
      },
      thanks: "Application sent — we’ll get back within 7 days.",
      contact_title: "Or just say hi",
    },
    contact: { title: "Contact us", email: "Email", phone: "Phone", whatsapp: "WhatsApp" },
    footer: {
      tagline: "Available across the island — coming soon to Matmata & Tataouine.",
      explore: "Explore", company: "Company", legal: "Legal", connect: "Connect",
      rights: "All rights reserved.", partner: "Activities by Sefer Tunisia",
    },
    legal: {
      tour: { title: "Tours & Groups", body: "We host private groups, retreats and creator tours across Djerba and southern Tunisia. Reach out at contact@wosteldjerba.com or via WhatsApp to design your itinerary." },
      house: { title: "House Rules", body: "Be kind to fellow travelers and the staff. Check-in from 12:30 (luggage drop available at reception any time). Check-out 11:00. Quiet hours 23:00 - 08:00. No smoking inside. Valid ID required at check-in. Pets on request. Respect Djerbian culture and the island." },
      cancel: { title: "Cancellation Policy", body: "Free cancellation up to 7 days before arrival for direct bookings. Cancellations within 7 days: first night non-refundable. No-show: full first night charged. Bookings via Hostelworld follow Hostelworld's policy. Contact us for force-majeure cases." },
      privacy: { title: "Privacy Policy", body: "We collect only what is necessary to manage your booking and reply to your messages: name, email, phone, dates. We never sell your data. You can request deletion at any time at contact@wosteldjerba.com." },
      terms: { title: "Terms & Conditions", body: "By booking with Wostel Djerba you agree to our House Rules, Cancellation Policy and the partner platform rules (Hostelworld). Wostel Djerba is the trade name for accommodation and travel services in Tunisia." },
    },
    admin: {
      login: "Admin login", email: "Email", password: "Password", signin: "Sign in",
      dashboard: "Dashboard", logout: "Sign out",
      tabs: { stays: "Stays", guides: "Guides", creators: "Creators", contacts: "Contacts" },
      addStay: "Add accommodation", addGuide: "Add guide",
      name: "Name", type: "Type", description_en: "Description (EN)", description_fr: "Description (FR)",
      location_name: "Location label", google_maps_url: "Google Maps URL", latitude: "Latitude", longitude: "Longitude",
      hostelworld_url: "Hostelworld booking URL", whatsapp_url: "WhatsApp booking URL",
      featured: "Featured on landing", published: "Published",
      images: "Images", uploadImage: "Upload image", uploadPdf: "Upload PDF",
      title_en: "Title (EN)", title_fr: "Title (FR)", category: "Category", cover_image: "Cover image URL", pdf_url: "PDF URL",
      save: "Save", cancel: "Cancel", edit: "Edit", delete: "Delete", confirmDelete: "Delete this entry?",
    },
  },
  fr: {
    nav: { home: "Accueil", stays: "Logements", guides: "Guides voyage", creator: "Créateurs", contact: "Contact", book: "Réserver" },
    hero: {
      eyebrow: "Sud Tunisien & Île de Djerba",
      title: "Une maison sur l’île,",
      titleAccent: "où que tu ailles.",
      sub: "Wostel Djerba, c’est une communauté de voyageurs, d’hôtes et de raconteurs d’histoires — Hostel, Maisons d’hôtes et Appartements partout sur l’île, bientôt Matmata & Tataouine.",
      ctaPrimary: "Voir nos logements",
      ctaSecondary: "Ouvrir les guides",
    },
    why: {
      eyebrow: "Pourquoi Wostel Djerba",
      title: "Pas juste des lits.",
      titleAccent: "Des expériences qu’on crée.",
      cards: [
        { title: "Trouve ta tribu", desc: "Arrive seul, repars en bande. Dîners sur le rooftop, journées plage et des histoires qui voyagent plus loin que toi." },
        { title: "Expériences authentiques", desc: "Notre partenaire Sefer Tunisia t’emmène hors des sentiers — villages berbères, nuits dans le désert, sorties pêche, Djerba cachée." },
        { title: "Meilleur tarif en direct", desc: "Réserve direct via WhatsApp, zéro commission plateforme. Mêmes lits, prix plus doux, plus d’amour pour l’équipe." },
        { title: "Partout dans le Sud", desc: "Hostel, maisons d’hôtes & appartements partout à Djerba — et très bientôt, Matmata & Tataouine." },
      ],
    },
    ratings: {
      eyebrow: "Plébiscité par les voyageurs",
      google: "sur Google Reviews",
      hostelworld: "sur Hostelworld",
    },
    offer: {
      eyebrow: "Ce qu’on propose",
      title: "Trois façons de loger,",
      titleAccent: "une seule communauté.",
      hostel: { name: "Hostel", desc: "Le cœur de Wostel — dortoirs partagés, cuisine commune, couchers de soleil sur le rooftop et les rires les plus francs de Djerba." },
      guest_house: { name: "Maisons d’hôtes", desc: "De vraies maisons djerbiennes — patio, murs blancs, porte bleue — l’intimité à ta façon." },
      apartment: { name: "Appartements", desc: "Ton propre espace sur l’île — cuisine, terrasse, brise marine, bureau pour digital nomads." },
    },
    activities: {
      eyebrow: "À faire",
      title: "Découvre Djerba avec",
      titleAccent: "Sefer Tunisia.",
      desc: "Notre partenaire Sefer Tunisia cure les expériences les plus authentiques en Tunisie — nuits dans le désert à Matmata, villages berbères, sorties en mer et food walks.",
      cta: "Voir les expériences",
    },
    featured: { eyebrow: "Coups de cœur", title: "Là où tu dormiras ce soir." },
    stays: {
      title: "Tous nos logements",
      sub: "Choisis ce qui colle à ton voyage — communauté, intimité ou indépendance.",
      filterAll: "Tout",
      filterHostel: "Hostel",
      filterGuest: "Maisons d’hôtes",
      filterApartment: "Appartements",
      bookHostelworld: "Réserver sur Hostelworld",
      bookWhatsapp: "Réserver par WhatsApp",
      viewMap: "Voir sur la carte",
      empty: "Aucun logement dans cette catégorie pour l’instant — reviens vite !",
    },
    guides: {
      title: "Guides voyage gratuits",
      sub: "Concoctés par l’équipe et les copains — télécharge, imprime, perds-toi.",
      download: "Télécharger le PDF",
      empty: "Les guides arrivent très bientôt.",
      chips: { pdfs: "PDFs gratuits", maps: "Cartes locales", offgrid: "Hors des sentiers" },
    },
    creator: {
      title: "Séjours gratuits pour créateurs",
      sub: "Storyteller, photographe, vidéaste ? Candidate pour un séjour offert en échange de contenu qui fait briller Djerba.",
      perks: { stay: "Séjour offert", tour: "Tour inclus", guide: "Guide local" },
      form: {
        full_name: "Nom complet", email: "Email", instagram: "Pseudo Instagram", tiktok: "Pseudo TikTok", youtube: "Chaîne YouTube",
        audience_size: "Taille d’audience (abonnés)", preferred_dates: "Dates souhaitées", message: "Parle-nous de toi & de ton idée",
        submit: "Envoyer ma candidature",
      },
      thanks: "Candidature envoyée — réponse sous 7 jours.",
      contact_title: "Ou juste un petit mot",
    },
    contact: { title: "Nous contacter", email: "Email", phone: "Téléphone", whatsapp: "WhatsApp" },
    footer: {
      tagline: "Présent sur toute l’île — bientôt à Matmata & Tataouine.",
      explore: "Explorer", company: "À propos", legal: "Légal", connect: "Suivre",
      rights: "Tous droits réservés.", partner: "Activités par Sefer Tunisia",
    },
    legal: {
      tour: { title: "Tours & Groupes", body: "On accueille groupes privés, retraites et tours créateurs à Djerba et dans le sud tunisien. Écris à contact@wosteldjerba.com ou WhatsApp pour construire ton itinéraire." },
      house: { title: "Règlement intérieur", body: "Sois respectueux envers les autres voyageurs et le staff. Check-in à partir de 12h30 (dépôt de bagages possible à la réception à toute heure). Check-out 11h. Calme entre 23h et 8h. Pas de cigarette à l’intérieur. Pièce d’identité requise. Animaux sur demande. Respecte la culture djerbienne." },
      cancel: { title: "Politique d’annulation", body: "Annulation gratuite jusqu’à 7 jours avant l’arrivée pour les réservations directes. Moins de 7 jours : 1ʳᵉ nuit non remboursable. No-show : 1ʳᵉ nuit facturée. Les réservations via Hostelworld suivent leur politique. Cas de force majeure : contacte-nous." },
      privacy: { title: "Confidentialité", body: "On ne collecte que le nécessaire pour gérer ta réservation et répondre : nom, email, téléphone, dates. On ne vend jamais tes données. Demande la suppression à tout moment via contact@wosteldjerba.com." },
      terms: { title: "Conditions générales", body: "En réservant avec Wostel Djerba, tu acceptes notre règlement, notre politique d’annulation et celles de nos partenaires (Hostelworld). Wostel Djerba est le nom commercial pour des services d’hébergement et de voyage en Tunisie." },
    },
    admin: {
      login: "Espace admin", email: "Email", password: "Mot de passe", signin: "Connexion",
      dashboard: "Tableau de bord", logout: "Déconnexion",
      tabs: { stays: "Logements", guides: "Guides", creators: "Créateurs", contacts: "Messages" },
      addStay: "Ajouter un logement", addGuide: "Ajouter un guide",
      name: "Nom", type: "Type", description_en: "Description (EN)", description_fr: "Description (FR)",
      location_name: "Nom du lieu", google_maps_url: "URL Google Maps", latitude: "Latitude", longitude: "Longitude",
      hostelworld_url: "Lien Hostelworld", whatsapp_url: "Lien WhatsApp",
      featured: "Mis en avant", published: "Publié",
      images: "Images", uploadImage: "Téléverser image", uploadPdf: "Téléverser PDF",
      title_en: "Titre (EN)", title_fr: "Titre (FR)", category: "Catégorie", cover_image: "URL image couverture", pdf_url: "URL du PDF",
      save: "Enregistrer", cancel: "Annuler", edit: "Modifier", delete: "Supprimer", confirmDelete: "Supprimer cette entrée ?",
    },
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("wostel_lang") || "en");
  useEffect(() => { document.documentElement.lang = lang; }, [lang]);
  const setLang = (l) => { localStorage.setItem("wostel_lang", l); setLangState(l); };
  const t = dict[lang];
  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
